import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useIsSavedUser = (userId: string | null | undefined) => {
  return useQuery({
    queryKey: ["is-saved", userId],
    queryFn: async () => {
      if (!userId) return false;

      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return false;

      const { data, error } = await supabase
        .from("saved_users")
        .select("id")
        .eq("user_id", user.id)
        .eq("saved_user_id", userId)
        .maybeSingle();

      if (error) throw error;
      return !!data;
    },
    enabled: !!userId,
  });
};
